import React, { useState } from "react";

const COLORS = {
  primary: "#1CA069",
  primaryDark: "#178a5a",
  dark: "#072D4B",
  text: "#3D4A52",
  border: "#dfe8e6",
  muted: "#7d8a88",
  accentBg: "rgba(28, 160, 105, 0.03)",
};

// Converts ALL-CAPS strings to Title Case (e.g., "TOTAL SCREENINGS" -> "Total Screenings")
function formatLabel(str) {
  if (!str) return "";
  if (str === str.toUpperCase()) {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  return str;
}

function MetricCard({ label, value, suffix, gender }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        background: isHovered ? COLORS.accentBg : "#fff",
        border: `1px solid ${isHovered ? COLORS.primary : COLORS.border}`,
        borderRadius: 14,
        padding: "20px 22px",
        display: "flex",
        flexDirection: "column",
        gap: 10,
        boxShadow: isHovered
          ? "0 10px 24px -4px rgba(7,45,75,0.12)"
          : "0 1px 3px rgba(7,45,75,0.05)",
        transform: isHovered ? "translateY(-3px)" : "translateY(0)",
        transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
        minHeight: 116,
        justifyContent: "center",
        cursor: "pointer",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Interactive Top Border Accent Line */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          background: COLORS.primary,
          opacity: isHovered ? 1 : 0,
          transition: "opacity 0.25s ease",
        }}
      />

      {gender ? (
        <div>
          <div
            style={{
              fontSize: 12.5,
              fontWeight: 600,
              color: COLORS.muted,
              marginBottom: 12,
              letterSpacing: "0.01em",
            }}
          >
            {formatLabel(label)}
          </div>

          {/* Male Progress */}
          <div style={{ marginBottom: 10 }}>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, fontWeight: 700, color: COLORS.primary, marginBottom: 4 }}>
              <span>Male</span>
              <span>{gender.male ? gender.male.toFixed(1) : 0}%</span>
            </div>
            <div style={{ height: 7, borderRadius: 999, overflow: "hidden", background: COLORS.border }}>
              <div
                style={{
                  width: `${gender.male || 0}%`,
                  height: "100%",
                  background: COLORS.primary,
                  borderRadius: 999,
                  transition: "width 0.8s ease-out",
                }}
              />
            </div>
          </div>

          {/* Female Progress */}
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, fontWeight: 700, color: COLORS.dark, marginBottom: 4 }}>
              <span>Female</span>
              <span>{gender.female ? gender.female.toFixed(1) : 0}%</span>
            </div>
            <div style={{ height: 7, borderRadius: 999, overflow: "hidden", background: COLORS.border }}>
              <div
                style={{
                  width: `${gender.female || 0}%`,
                  height: "100%",
                  background: COLORS.dark,
                  borderRadius: 999,
                  transition: "width 0.8s ease-out",
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div
            style={{
              fontSize: 12.5,
              color: COLORS.muted,
              fontWeight: 600,
              marginBottom: 8,
              letterSpacing: "0.01em",
            }}
          >
            {formatLabel(label)}
          </div>
          <div
            style={{
              fontSize: 28,
              fontWeight: 700,
              color: isHovered ? COLORS.primaryDark : COLORS.primary,
              lineHeight: 1.1,
              letterSpacing: "-0.01em",
              transition: "color 0.2s ease",
            }}
          >
            {value === null || value === undefined ? "—" : value}
            {suffix ? <span style={{ fontSize: 14, fontWeight: 600, marginLeft: 3 }}>{suffix}</span> : null}
          </div>
        </div>
      )}
    </div>
  );
}

export default MetricCard;